// File: src/components/pages/Dashboard.jsx
// Role router — dispatches to StudentDashboard or InstructorDashboard

import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { AUTH0_NAMESPACE, ROLES } from '../../utils/constants';
import StudentDashboard from './StudentDashboard';
import InstructorDashboard from './InstructorDashboard';

const Dashboard = () => {
  const { user, getAccessTokenSilently } = useAuth0();
  const userRoles = user?.[`${AUTH0_NAMESPACE}/roles`] || [];
  const isStudent = userRoles.includes(ROLES.SERVICEUSER);

  if (isStudent) {
    return <StudentDashboard user={user} getAccessTokenSilently={getAccessTokenSilently} />;
  }

  return <InstructorDashboard user={user} getAccessTokenSilently={getAccessTokenSilently} />;
};

export default Dashboard;